/* eslint-disable */
import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function BillingSuccess() {
  const [sp] = useSearchParams();
  const sessionId = sp.get("session_id");
  const { refresh } = useAuth();
  const [status, setStatus] = useState("polling");
  const [attempts, setAttempts] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let stop = false;
    const poll = async (n) => {
      if (stop) return;
      if (n >= 8) { setStatus("timeout"); return; }
      try {
        const r = await api.get(`/billing/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          refresh();
          return;
        }
        if (r.data.status === "expired") { setStatus("expired"); return; }
        setAttempts(n + 1);
        timerRef.current = setTimeout(() => poll(n + 1), 2000);
      } catch (e) {
        setStatus("error");
      }
    };
    poll(0);
    return () => { stop = true; if (timerRef.current) clearTimeout(timerRef.current); };
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B111D] p-6">
      <div className="card-flat p-10 max-w-md w-full text-center" data-testid="billing-success">
        {status === "polling" && (
          <>
            <Loader2 size={48} className="mx-auto animate-spin text-[#00BFFF]"/>
            <h1 className="font-display text-2xl font-extrabold mt-6">Procesăm plata...</h1>
            <p className="text-sm text-[#94A3B8] mt-2">Verificare {attempts + 1} / 8</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={56} className="mx-auto text-[#22C55E]"/>
            <h1 className="font-display text-2xl font-extrabold mt-6">Plată reușită!</h1>
            <p className="text-sm text-[#94A3B8] mt-2">Abonamentul tău este activ.</p>
            <Link to="/app/oferte" className="btn-primary mt-6 inline-block" data-testid="back-to-app">Înapoi în aplicație</Link>
          </>
        )}
        {(status === "expired" || status === "error" || status === "timeout") && (
          <>
            <XCircle size={56} className="mx-auto text-[#EF4444]"/>
            <h1 className="font-display text-2xl font-extrabold mt-6">Plată nereușită</h1>
            <p className="text-sm text-[#94A3B8] mt-2">Plata nu s-a finalizat. Te rugăm să încerci din nou.</p>
            <Link to="/app/abonament" className="btn-outline mt-6 inline-block">Înapoi la planuri</Link>
          </>
        )}
      </div>
    </div>
  );
}
